module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('div', {
    staticClass: "nodata flex justify-center align-center flex-direction",
    staticStyle: {
      "height": "300px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": require("../assets/img/index/empty.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("\n                暂无数据\n            ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f9de57b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nomore.vue
// module id = 889
// module chunks = 1